import { skipToken, useQuery } from '@tanstack/react-query';
import { streamsPayloadSchema, type StreamsPayload } from '@painpal/contracts';
import { queryKeys } from '../../api/keys';
import { ApiRequestError } from '../../lib/api';

export async function fetchStreams(url: string): Promise<StreamsPayload> {
  const response = await fetch(url);
  if (!response.ok) throw new ApiRequestError(response.status, 'streams_unavailable', 'Ride data could not be loaded');
  const json: unknown = await response.json();
  return streamsPayloadSchema.parse(json);
}

// Keyed by activity id: the presigned URL is re-signed on every detail fetch, so it is only the fetch input.
export function useStreams(activityId: string, url: string) {
  return useQuery({ queryKey: queryKeys.streams(activityId), queryFn: () => fetchStreams(url), staleTime: Infinity });
}

// The same cached streams as useStreams, for a page that may have none: disabled without a URL.
export function useActivityStreams(activityId: string, url: string | null) {
  return useQuery({ queryKey: queryKeys.streams(activityId), queryFn: url === null ? skipToken : () => fetchStreams(url), staleTime: Infinity });
}
